import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = s((i, e) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: e,
    ...i,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69091)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 2v12A6 6 0 0 0 8 2",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69091", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
t.displayName = "ContrastIcon";
export {
  t as ContrastIcon,
  t as default
};
//# sourceMappingURL=index.js.map
